//   const animalKeyword = [
//     "animal", "cow", "dog", "cat", "lion", "tiger",
//     "bird", "monkey", "horse", "sheep", "goat",
//     "wildlife", "pet", "puppy", "kitten",
//     "chicken", "hen", "duck", "fish",
//     "zoo", "farm animal", "cattle", "hourse", "mosquitos", "mosquito", 
//     "insect", "insects", "grasshopper", "grasshoppers",  "katydid", "bee", "honey bee", "butterfly", "moth",  "ant", "ants", "spider",  "bug", "bugs", "deer", "seagull"

//   ];


// function isAnimalImage(img) {
//   if (!img?.tags) return false;

//   const tags = img.tags.toLowerCase();

//   return animalKeyword.some(keyword => tags.includes(keyword));
// }




// export function softSortByInterest(images) {
//   return images
//     .map((img) => ({
//       ...img,
//       _interestWeight:
//         (img._interestScore || 0) +
//         ((img.id % 10) / 10) * 8, // stable pseudo-random
//     }))
//     .sort((a, b) => b._interestWeight - a._interestWeight);
// }

// function computeStrengthScore(img) {
//   const likes = img.likes || 0;
//   const downloads = img.downloads || 0;
//   const views = img.views || 0;
//   const favorites = img.favorites || 0;

//   const width = img.imageWidth || 0;
//   const height = img.imageHeight || 0;

//   const resolution = width * height;

//   // Normalize resolution (MP = megapixels)
//   const resolutionScore = resolution / 1_000_000;

//   return (
//     likes * 3 +          // strong signal
//     downloads * 2 +      // strong signal
//     views * 0.15 +       // weaker signal
//     favorites * 2 +      // optional
//     resolutionScore      // quality bonus
//   );
// }

// function aspectBonus(img) {
//   const w = img.imageWidth || 1;
//   const h = img.imageHeight || 1;

//   const ratio = w / h;

//   // Preferred landscape (looks strong in hero grids)
//   if (ratio > 1.2 && ratio < 2.2) return 5;

//   // Slight bonus for portrait images
//   if (ratio < 0.8) return 2;

//   // No bonus for square / extreme ratios
//   return 0;
// }


// function topicRelevanceScore(img, query) {
//   const tags = (img.tags || "").toLowerCase()
//   const q = (query || "").toLowerCase()

//   if (!q) return 0

//   if (tags.includes(q)) return 10

//   const firstTag = tags.split(",")[0]?.trim()
//   if (firstTag === q) return 15

//   return 0
// }
// function diversifyByUser(images) {
//   const used = new Set()

//   return images.filter(img => {
//     if (!img.user) return true
//     if (used.has(img.user)) return false
//     used.add(img.user)
//     return true
//   })
// }



// function boringPenalty(img) {
//   const tags = (img.tags || "").toLowerCase();

//   if (
//     tags.includes("background") ||
//     tags.includes("wall") ||
//     tags.includes("texture")
//   ) {
//     return -20;
//   }

//   return 0;
// }






// // export function pickStrongTopImages(images, query, count = 6) {

// //   let source = Array.isArray(images) ? images : [];

// //   // 🔥 STEP 1: Animal filtering
// //   const q = (query || "").toLowerCase();

// //   const isAnimalQuery = animalKeyword.some(keyword =>
// //     q.includes(keyword)
// //   );

// //   if (!isAnimalQuery) {
// //     source = source.filter(img => !isAnimalImage(img));
// //   }

// //   // 🔥 STEP 2: Fallback (IMPORTANT)
// //   if (source.length < count) {
// //     source = Array.isArray(images) ? images : [];
// //   }

// //   console.log("source length", source);

// //   if (source.length === 0) return [];

// //   // 🔥 STEP 3: Ranking
// //   const ranked = source
// //     .map(img => {
// //       const strength = computeStrengthScore(img);
// //       const relevance = topicRelevanceScore(img, query);
// //       const aspect = aspectBonus(img);

// //       return {
// //         ...img,
// //         _rank:
// //           strength +
// //           relevance * 12 +
// //           aspect +
// //           ((img.id % 10) / 10) * 3 +
// //           boringPenalty(img) +
// //           ((img.likes || 0) > 50 ? 20 : 0)
// //       };
// //     })
// //     .sort((a, b) => b._rank - a._rank);

// //   // 🔥 STEP 4: Diversify
// //   const diversified = diversifyByUser(ranked) || [];

// //   let result = diversified.slice(0, count);

// //   // 🔥 STEP 5: Force strong HERO image (NO DUPLICATE)
// //   if (ranked.length > 0) {
// //     const hero = ranked[0];

// //     // remove hero if already exists
// //     const filtered = result.filter(img => img.id !== hero.id);

// //     result = [hero, ...filtered.slice(0, count - 1)];
// //   }

// //   // 🔥 STEP 6: Fill remaining safely
// //   if (result.length < count) {
// //     const usedIds = new Set(result.map(img => img.id));

// //     for (const img of ranked) {
// //       if (!usedIds.has(img.id)) {
// //         result.push(img);
// //         usedIds.add(img.id);

// //         if (result.length === count) break;
// //       }
// //     }
// //   }

// //   // 🔥 STEP 7: Final fallback (rare case)
// //   let i = 0;
// //   while (result.length < count && ranked.length > 0) {
// //     result.push(ranked[i % ranked.length]);
// //     i++;
// //   }

// //   console.log("final ranked images", result);

// //   return result;
// // }



// // ----------------------------------------------------------------------------------------------------------------------------------

// //   const animalKeyword = [
// //     "animal", "cow", "dog", "cat", "lion", "tiger",
// //     "bird", "monkey", "horse", "sheep", "goat",
// //     "wildlife", "pet", "puppy", "kitten",
// //     "chicken", "hen", "duck", "fish",
// //     "zoo", "farm animal", "cattle", "hourse", "mosquitos", "mosquito"
// //   ];


// // function isAnimalImage(img) {
// //   if (!img?.tags) return false;

// //   const tags = img.tags.toLowerCase();

// //   return animalKeyword.some(keyword => tags.includes(keyword));
// // }




// // export function softSortByInterest(images) {
// //   return images
// //     .map((img) => ({
// //       ...img,
// //       _interestWeight:
// //         (img._interestScore || 0) +
// //         ((img.id % 10) / 10) * 8, // stable pseudo-random
// //     }))
// //     .sort((a, b) => b._interestWeight - a._interestWeight);
// // }

// // function computeStrengthScore(img) {
// //   const likes = img.likes || 0;
// //   const downloads = img.downloads || 0;
// //   const views = img.views || 0;
// //   const favorites = img.favorites || 0;

// //   const width = img.imageWidth || 0;
// //   const height = img.imageHeight || 0;

// //   const resolution = width * height;

// //   // Normalize resolution (MP = megapixels)
// //   const resolutionScore = resolution / 1_000_000;

// //   return (
// //     likes * 3 +          // strong signal
// //     downloads * 2 +      // strong signal
// //     views * 0.15 +       // weaker signal
// //     favorites * 2 +      // optional
// //     resolutionScore      // quality bonus
// //   );
// // }

// // function aspectBonus(img) {
// //   const w = img.imageWidth || 1;
// //   const h = img.imageHeight || 1;

// //   const ratio = w / h;

// //   // Preferred landscape (looks strong in hero grids)
// //   if (ratio > 1.2 && ratio < 2.2) return 5;

// //   // Slight bonus for portrait images
// //   if (ratio < 0.8) return 2;

// //   // No bonus for square / extreme ratios
// //   return 0;
// // }


// // function topicRelevanceScore(img, query) {
// //   const tags = (img.tags || "").toLowerCase()
// //   const q = (query || "").toLowerCase()

// //   if (!q) return 0

// //   if (tags.includes(q)) return 10

// //   const firstTag = tags.split(",")[0]?.trim()
// //   if (firstTag === q) return 15

// //   return 0
// // }
// // function diversifyByUser(images) {
// //   const used = new Set()

// //   return images.filter(img => {
// //     if (!img.user) return true
// //     if (used.has(img.user)) return false
// //     used.add(img.user)
// //     return true
// //   })
// // }


// // // function boringPenalty(img) {
// // //   const tags = (img.tags || "").toLowerCase();

// // //   if (
// // //     tags.includes("background") ||
// // //     tags.includes("wall") ||
// // //     tags.includes("texture")
// // //   ) {
// // //     return -50;
// // //   }

// // //   return 0;
// // // }

// function hasStrongSubject(img) {
//   const tags = (img.tags || "").toLowerCase();

//   return (
//     tags.includes("person") ||
//     // tags.includes("man") ||
//     // tags.includes("woman") ||
//     tags.includes("people") ||
//     tags.includes("animal") ||
//     // tags.includes("bird") ||
//     tags.includes("road") ||
//     tags.includes("car") ||
//     tags.includes("boat") ||
//     tags.includes("tree") ||
//     tags.includes("building") ||
//     tags.includes("mountain")
//   );
// }

// function extractMainKeyword(query) {
//   if (!query) return "";

//   const words = query.toLowerCase().split(" ");

//   // pick first strong word
//   return words[0]; // "bedroom", "kitchen", "sunset"
// }

// function queryMatchBoost(img, query) {
//   const tags = (img.tags || "").toLowerCase();
//   const main = extractMainKeyword(query);

//   if (!main) return 0;

//   // strong match
//   if (tags.includes(main)) return 30;

//   return 0;
// }

// function fillRemaingImage(result,ranked, query,  count){
//  if (result.length < count) {
//   const usedIds = new Set(result.map(img => img.id));
//   const main = extractMainKeyword(query);

//   for (const img of ranked) {
//     if (result.length === count) break;

//     if (usedIds.has(img.id)) continue;

//     const tags = (img.tags || "").toLowerCase();

//     // ❌ skip weak images (no subject + no query match)
//     // if (!hasStrongSubject(img) && !tags.includes(main)) {
//     //   continue;
//     // }

//     if (!tags.includes(main)) {
//   continue;
// }

//     // ✅ prioritize query match
//     if (tags.includes(main)) {
//       result.push(img);
//       usedIds.add(img.id);
//       continue;
//     }

//     // ✅ then strong subject
//     if (hasStrongSubject(img)) {
//       result.push(img);
//       usedIds.add(img.id);
//       continue;
//     }
//   }
// } 
// }

// // export function pickStrongTopImages(images, query, count = 6, selectPexels = false) {
// // console.log("image ranking", query)
// //   let source = Array.isArray(images) ? images : [];

// //   // 🔥 STEP 1: Animal filtering
// //   const q = (query || "").toLowerCase();

// //   const isAnimalQuery = animalKeyword.some(keyword =>
// //     q.includes(keyword)
// //   );

// //   if (!isAnimalQuery) {
// //     source = source.filter(img => !isAnimalImage(img));
// //   }

// //   // 🔥 STEP 2: Fallback (IMPORTANT)
// //   if (source.length < count) {
// //     source = Array.isArray(images) ? images : [];
// //   }

// //   console.log("source length", source);

// //   if (source.length === 0) return [];

// //   // 🔥 STEP 3: Ranking
// //   const ranked = source
// //     .map(img => {
// //       const strength = computeStrengthScore(img);
// //       const relevance = topicRelevanceScore(img, query);
// //       const aspect = aspectBonus(img);
// //       const subjectBoost = hasStrongSubject(img) ? 20 : -10;
// //       const queryBoost = queryMatchBoost(img, query);

// //       const visualBoost =
// //       (img.webformatWidth > 800 ? 5 : 0) +
// //       (img.imageWidth > img.imageHeight ? 3 : 0);

// //       return {
// //         ...img,
// //         _rank:
// //           strength * 1.5  +
// //           relevance * 6 +
// //           aspect +
// //           visualBoost + 
// //           subjectBoost +
// //           queryBoost + 
// //           ((img.likes || 0) > 50 ? 20 : 0)
// //       };
// //     })
// //     .sort((a, b) => b._rank - a._rank);

// //   // 🔥 STEP 4: Diversify
// //   // const diversified = diversifyByUser(ranked) || [];

// //   // let result = diversified.slice(0, count);
// //   let result = ranked.slice(0, count)


// //   result = addPexels(selectPexels, ranked, result, count)
  

// //   // 🔥 STEP 5: Force strong HERO image (NO DUPLICATE)
// //   if (ranked.length > 0) {
// //     const hero = ranked[0];

// //     // remove hero if already exists
// //     const filtered = result.filter(img => img.id !== hero.id);

// //     result = [hero, ...filtered.slice(0, count - 1)];
// //   }

  

  

// //   fillRemaingImage(result, ranked, query, count)

// //   console.log("final ranked images", result);

// //   return result;
// // }

// function addPexels(selectPexels, ranked, result, count){

//   if (!selectPexels) {
//     return result;
//   }

//   const bestPexels = ranked.find(
//     img => img._source === "pexels"
//   );

//   if (!bestPexels) {
//     return result;
//   }

//   // Remove ALL pexels from result
//   result = result.filter(
//     img => img._source !== "pexels"
//   );

//   // Insert exactly one
//   result.splice(3, 0, bestPexels);

//   return result.slice(0, count);
// }


// // ----------------------------------------------------------------------------------------------------------------------------------

// // ------------------------
// // 🔥 VISUAL IMPACT SYSTEM
// // ------------------------

// function visualImpactScore(img) {
//   const tags = (img.tags || "").toLowerCase();

//   let score = 0;

//   // 🔥 High impact subjects
//   if (
//     tags.includes("person") ||
//     tags.includes("portrait") ||
//     tags.includes("face") ||
//     // tags.includes("cat") ||
//     tags.includes("car") ||
//     tags.includes("plane") ||
//     tags.includes("mountain") ||
//     tags.includes("sunset") ||
//     tags.includes("dramatic") ||
//     tags.includes("macro") ||
//     tags.includes("close up")
//   ) {
//     score += 30;
//   }

//   // 🔥 Emotional / aesthetic triggers
//   if (
//     tags.includes("aesthetic") ||
//     tags.includes("cinematic") ||
//     tags.includes("colorful")
//   ) {
//     score += 20;
//   }

//   // ❌ boring backgrounds
//   if (
//     tags.includes("background") ||
//     tags.includes("texture") ||
//     tags.includes("wall") ||
//     tags.includes("pattern") ||    tags.includes("cat")
//   ) {
//     score -= 60;
//   }

//   return score;
// }


// // ------------------------
// // 🔥 SUBJECT BOOST
// // ------------------------

// function subjectBoost(img) {
//   const tags = (img.tags || "").toLowerCase();

//   if (
//     tags.includes("person") ||
//     tags.includes("animal") ||
//     tags.includes("vehicle") ||
//     tags.includes("architecture")
//   ) {
//     return 20;
//   }

//   return 0;
// }


// // ------------------------
// // 🔥 UPDATED MAIN FUNCTION
// // ------------------------

// function orderPixlesAndPixbay(firstScreen, rest){
//   const mixedTop = [];
//   const pixabayFirst = false
// for (
//   let i = 0;
//   i < Math.max(firstScreen.length, rest.length);
//   i++
// ) {

//   if(pixabayFirst){  
//         // 🔥 Pixabay-ranked image first
//         if (firstScreen[i]) {
//           mixedTop.push(firstScreen[i]);
//         }

//         // 🔥 Then pexels
//         if (rest[i]) {
//           mixedTop.push(rest[i]);
//         }

//   }else{

//           // 🔥 Then pexels
//         if (rest[i]) {
//           mixedTop.push(rest[i]);
//         }

//           // 🔥 Pixabay-ranked image first
//         if (firstScreen[i]) {
//           mixedTop.push(firstScreen[i]);
//         }

//   }
// }

// return mixedTop;
// }

// function isTooWeakImageFeed(source) {

//   const strongImages = source.filter(img => {

//     const likes = img.likes || 0;
//     const views = img.views || 0;
//     const downloads = img.downloads || 0;

//     return (
//       likes >= 20 ||
//       views >= 5000 ||
//       downloads >= 1000
//     );
//   });

//   // 🔥 If NO strong images exist
//   if (strongImages.length === 0) {

//     return source
//       .filter(img => !isAnimalImage(img)).sort((a, b) => (b.likes || 0) - (a.likes || 0))
//       .slice(0, 9);
//   }

//   return null;
// }


// export function pickStrongTopImages(images, query, count = 6, selectPexels = false) {
//   let source = Array.isArray(images) ? images : [];
 
// console.log("getting iimage on picktopimage", source)
//   if (source.length === 0) return [];

//         // 🔥 CHECK WEAK FEED
//   const weakFeed = isTooWeakImageFeed(source);

//   if (weakFeed) {
//     console.log("Weak feed detected");
//     return weakFeed;
//   }

//   // ------------------------
//   // 🔥 STEP 1: BASE RANKING (your system)
//   // ------------------------

//   const ranked = source
//     .map(img => {
//       const strength = computeStrengthScore(img);
//       const relevance = topicRelevanceScore(img, query);
//       const aspect = aspectBonus(img);

//       return {
//         ...img,
//         _baseRank:
//           strength +
//           relevance * 12 +
//           aspect +
//           ((img.id % 10) / 10) * 3 +
//           ((img.likes || 0) > 50 ? 20 : 0)
//       };
//     })
//     .sort((a, b) => b._baseRank - a._baseRank);

//   // ------------------------
//   // 🔥 STEP 2: FIRST SCREEN BOOST
//   // ------------------------

//   const boosted = ranked.map(img => {
//     const visual = visualImpactScore(img);
//     const subject = subjectBoost(img);

//     return {
//       ...img,
//       _finalRank: img._baseRank + visual + subject
//     };
//   }).sort((a, b) => b._finalRank - a._finalRank);

//   // ------------------------
//   // 🔥 STEP 3: FIRST SCREEN OVERRIDE
//   // ------------------------

//   const firstScreenCount = 6;

//   // const firstScreen = boosted.slice(0, firstScreenCount);

//   const filteredBoosted = boosted.filter(img => !isAnimalImage(img) );

// const firstScreen = filteredBoosted.length >= firstScreenCount ? filteredBoosted.slice(0, firstScreenCount) : boosted.slice(0, firstScreenCount); 

//   // ------------------------
//   // 🔥 STEP 4: REST OF FEED (original logic)
//   // ------------------------

//   const usedIds = new Set(firstScreen.map(img => img.id));


//   if(!selectPexels){

// let nextImageLength = 9 - firstScreen.length;
//   //  const  rest = ranked.filter(img => img?._source !== "pexels" && !usedIds.has(img.id) && !isAnimalImage(img)).slice(0, nextImageLength);  
//    fillRemaingImage(firstScreen, ranked, query, count)

//     // return [ ...firstScreen, ...rest ];
//     return [ ...firstScreen];
    
//   }else{
// //       let nextImageLength = firstScreen.length === 4 ? 3 : 3
// //   const rest = ranked.filter(img => img?._source === "pexels" && !usedIds.has(img.id)  && !isAnimalImage(img)).slice(0, nextImageLength);

// //   let mixImages = orderPixlesAndPixbay(firstScreen, rest)
// // return [...mixImages];

// return filterPexelsImage(
//   source,
//   query
// )

//   }



//   // ------------------------
//   // 🔥 FINAL COMBINE
//   // ------------------------

//   // return [ ...firstScreen, ...rest ];
//   // return [...mixImages];
  
//   // return [...firstScreen];
// }


// function filterPexelsImage(
//   source,
//   query
// ){

//   // 🔥 PIXABAY ONLY
//   const pixabayImages =
//     source.filter(
//       img =>
//         img?._source !== "pexels" &&
//         !isAnimalImage(img)
//     );

//   // 🔥 PEXELS ONLY
//   const pexelsImages =
//     source.filter(
//       img =>
//         img?._source === "pexels" 
//     );

//   // 🔥 RANK ONLY PIXABAY
//   const rankedPixabay =  pixabayImages.map(img => {

//         const strength =
//           computeStrengthScore(img);

//         const relevance =
//           topicRelevanceScore(
//             img,
//             query
//           );

//         const aspect =
//           aspectBonus(img);

//         return {
//           ...img,
//           _score:
//             strength +
//             relevance * 12 +
//             aspect +
//             ((img.id % 10) / 10) * 3 +
//             ((img.likes || 0) > 50 ? 20 : 0)
//         };

//       })
//       .sort(
//         (a, b) =>
//           b._score - a._score
//       );

//   // 🔥 EXACTLY 6 PIXABAY
//   // console.log("strong filter images", rankedPixabay)
//   const topPixabay =  rankedPixabay.slice(0, 6);
//    fillRemaingImage(rankedPixabay, topPixabay, query, 6)
//   // 🔥 EXACTLY 3 PEXELS
//   const topPexels =  pexelsImages.slice(0, 3);
//   console.log("image starting point 8", topPixabay, topPexels)

//   // 🔥 FIXED STRUCTURE
//   return [

//     topPexels[0],

//     topPixabay[0],
//     topPixabay[1],
//     topPixabay[2],


// //     topPexels[0],
// // topPexels[1],
// //     topPexels[2],

//     topPexels[1],

//     topPixabay[3],
//     topPixabay[4],

    
//     topPixabay[5],

// // topPexels[0],
// // topPexels[1],
//     topPexels[2],


//   ].filter(Boolean);

// }



// ---------------------------------------- New code starts from below ------------------


  const animalKeyword = [
    "animal", "cow", "dog", "cat", "lion", "tiger",
    "bird", "monkey", "horse", "sheep", "goat",
    "wildlife", "pet", "puppy", "kitten",
    "chicken", "hen", "duck", "fish", "elephants", "elephant", "baboon",
    "zoo", "farm animal", "cattle", "hourse", "mosquitos", "mosquito", 
    "insect", "insects", "grasshopper", "grasshoppers",  "katydid", "bee", "honey bee", "butterfly", "moth",  "ant", "ants", "spider",  "bug", "bugs", "deer", "seagull"

  ];


function isAnimalImage(img) {
  if (!img?.tags) return false;

  const tags = img.tags.toLowerCase();

  return animalKeyword.some(keyword => tags.includes(keyword));
}




export function softSortByInterest(images) {
  return images
    .map((img) => ({
      ...img,
      _interestWeight:
        (img._interestScore || 0) +
        ((img.id % 10) / 10) * 8, // stable pseudo-random
    }))
    .sort((a, b) => b._interestWeight - a._interestWeight);
}

function computeStrengthScore(img) {
  const likes = img.likes || 0;
  const downloads = img.downloads || 0;
  const views = img.views || 0;
  const favorites = img.favorites || 0;

  const width = img.imageWidth || 0;
  const height = img.imageHeight || 0;

  const resolution = width * height;

  // Normalize resolution (MP = megapixels)
  const resolutionScore = resolution / 1_000_000;

  return (
    likes * 3 +          // strong signal
    downloads * 2 +      // strong signal
    views * 0.15 +       // weaker signal
    favorites * 2 +      // optional
    resolutionScore      // quality bonus
  );
}

function aspectBonus(img) {
  const w = img.imageWidth || 1;
  const h = img.imageHeight || 1;

  const ratio = w / h;

  // Preferred landscape (looks strong in hero grids)
  if (ratio > 1.2 && ratio < 2.2) return 5;

  // Slight bonus for portrait images
  if (ratio < 0.8) return 2;

  // No bonus for square / extreme ratios
  return 0;
}


function topicRelevanceScore(img, query) {
  // const tags = (img.tags || "").toLowerCase()
  // const q = (query || "").toLowerCase()

  // if (!q) return 0

  // if (tags.includes(q)) return 10

  // const firstTag = tags.split(",")[0]?.trim()
  // if (firstTag === q) return 15

  // return 0

    return exactRelevanceScore(img, query);
}
function diversifyByUser(images) {
  const used = new Set()

  return images.filter(img => {
    if (!img.user) return true
    if (used.has(img.user)) return false
    used.add(img.user)
    return true
  })
}



function boringPenalty(img) {
  const tags = (img.tags || "").toLowerCase();

  if (
    tags.includes("background") ||
    tags.includes("wall") ||
    tags.includes("texture")
  ) {
    return -20;
  }

  return 0;
}








function hasStrongSubject(img) {
  const tags = (img.tags || "").toLowerCase();

  return (
    tags.includes("person") ||
    // tags.includes("man") ||
    // tags.includes("woman") ||
    tags.includes("people") ||
    tags.includes("animal") ||
    // tags.includes("bird") ||
    tags.includes("road") ||
    tags.includes("car") ||
    tags.includes("boat") ||
    tags.includes("tree") ||
    tags.includes("building") ||
    tags.includes("mountain")
  );
}

function extractMainKeyword(query) {
  if (!query) return "";

  const words = query.toLowerCase().split(" ");

  // pick first strong word
  return words[0]; // "bedroom", "kitchen", "sunset"
}
function getQueryMatchInfo(img, query) {
  const queryTokens = tokenizeText(query);
  const tagTokens = new Set(getImageTagTokens(img));

  const matchedTokens = queryTokens.filter(token =>
    tagTokens.has(token)
  );

  const coverage =
    queryTokens.length
      ? matchedTokens.length / queryTokens.length
      : 0;

  return {
    matchedTokens,
    coverage
  };
}

function normalizeText(value = "") {
  return decodeURIComponent(String(value))
    .toLowerCase()
    .replace(/[-_+/]+/g, " ")
    .replace(/[^\p{L}\p{N}\s]/gu, " ")
    .replace(/\s+/g, " ")
    .trim();
}
function tokenizeText(value = "") {
  return normalizeText(value)
    .split(" ")
    .filter(Boolean).map(normalizeWord)
    .filter(Boolean);
}

function getImageTagTokens(img) {
  return String(img?.tags || "")
    .split(",")
    .flatMap(tag => tokenizeText(tag))
    .filter(Boolean);
}

function exactRelevanceScore(img, query) {
  const queryTokens = tokenizeText(query);
  const tagTokens = getImageTagTokens(img);

  if (!queryTokens.length || !tagTokens.length) {
    return 0;
  }

  const tagSet = new Set(tagTokens);

  // Exact query phrase
  const normalizedQuery = normalizeText(query);
  const normalizedTags = normalizeText(img.tags || "");

  let score = 0;

  // --------------------------------
  // 1. Exact full query match
  // --------------------------------

  if (normalizedTags === normalizedQuery) {
    score += 100;
    return score;
  }

  // --------------------------------
  // 2. Individual query-token matches
  // --------------------------------

  let matchedWeight = 0;
  let totalWeight = 0;

  for (const token of queryTokens) {

    // Longer words are usually more specific.
    const weight =
      1 + Math.min(Math.max(token.length - 3, 0) / 10, 0.5);

    totalWeight += weight;

    if (tagSet.has(token)) {
      matchedWeight += weight;
    }
  }

  if (totalWeight > 0) {
    score += (matchedWeight / totalWeight) * 75;
  }

  // --------------------------------
  // 3. Exact phrase inside tags
  // --------------------------------

  if (
    queryTokens.length > 1 &&
    normalizedTags.includes(normalizedQuery)
  ) {
    score += 25;
  }

  return Math.min(score, 100);
}

function queryMatchBoost(img, query) {
  const tags = (img.tags || "").toLowerCase();
  const main = extractMainKeyword(query);

  if (!main) return 0;

  // strong match
  if (tags.includes(main)) return 30;

  return 0;
}

function fillRemaingImage(result,ranked, query,  count){
 if (result.length < count) {
  const usedIds = new Set(result.map(img => img.id));
  // const main = extractMainKeyword(query);

  for (const img of ranked) {
    if (result.length === count) break;

    if (usedIds.has(img.id)) continue;

    const tags = (img.tags || "").toLowerCase();

    // ❌ skip weak images (no subject + no query match)
    // if (!hasStrongSubject(img) && !tags.includes(main)) {
    //   continue;
    // }

//     if (!tags.includes(main)) {
//   continue;
// }
    const match = getQueryMatchInfo(img, query);
   // Require at least one exact query token.
    if (match.coverage <= 0) {
      continue;
    }
    // Do not re-add animals for non-animal queries
if (!isAnimalQuery(query) && isAnimalImage(img)) {
  continue;
}
    // ✅ prioritize query match
    // if (tags.includes(main)) {
      result.push(img);
      usedIds.add(img.id);
    //   continue;
    // }

    // ✅ then strong subject
  //   if (hasStrongSubject(img)) {
  //     result.push(img);
  //     usedIds.add(img.id);
  //     continue;
  //   }
  }
} 
}

function addPexels(selectPexels, ranked, result, count){

  if (!selectPexels) {
    return result;
  }

  const bestPexels = ranked.find(
    img => img._source === "pexels"
  );

  if (!bestPexels) {
    return result;
  }

  // Remove ALL pexels from result
  result = result.filter(
    img => img._source !== "pexels"
  );

  // Insert exactly one
  result.splice(3, 0, bestPexels);

  return result.slice(0, count);
}


// ----------------------------------------------------------------------------------------------------------------------------------

// ------------------------
// 🔥 VISUAL IMPACT SYSTEM
// ------------------------

function visualImpactScore(img) {
  const tags = (img.tags || "").toLowerCase();

  let score = 0;

  // 🔥 High impact subjects
  if (
    tags.includes("person") ||
    tags.includes("portrait") ||
    tags.includes("face") ||
    // tags.includes("cat") ||
    tags.includes("car") ||
    tags.includes("plane") ||
    tags.includes("mountain") ||
    tags.includes("sunset") ||
    tags.includes("dramatic") ||
    tags.includes("macro") ||
    tags.includes("close up")
  ) {
    score += 30;
  }

  // 🔥 Emotional / aesthetic triggers
  if (
    tags.includes("aesthetic") ||
    tags.includes("cinematic") ||
    tags.includes("colorful")
  ) {
    score += 20;
  }

  // ❌ boring backgrounds
  if (
    tags.includes("background") ||
    tags.includes("texture") ||
    tags.includes("wall") ||
    tags.includes("pattern") ||    tags.includes("cat")
  ) {
    score -= 60;
  }

  return score;
}


// ------------------------
// 🔥 SUBJECT BOOST
// ------------------------

function subjectBoost(img) {
  const tags = (img.tags || "").toLowerCase();

  if (
    tags.includes("person") ||
    tags.includes("animal") ||
    tags.includes("vehicle") ||
    tags.includes("architecture")
  ) {
    return 20;
  }

  return 0;
}


// ------------------------
// 🔥 UPDATED MAIN FUNCTION
// ------------------------

function orderPixlesAndPixbay(firstScreen, rest){
  const mixedTop = [];
  const pixabayFirst = false
for (
  let i = 0;
  i < Math.max(firstScreen.length, rest.length);
  i++
) {

  if(pixabayFirst){  
        // 🔥 Pixabay-ranked image first
        if (firstScreen[i]) {
          mixedTop.push(firstScreen[i]);
        }

        // 🔥 Then pexels
        if (rest[i]) {
          mixedTop.push(rest[i]);
        }

  }else{

          // 🔥 Then pexels
        if (rest[i]) {
          mixedTop.push(rest[i]);
        }

          // 🔥 Pixabay-ranked image first
        if (firstScreen[i]) {
          mixedTop.push(firstScreen[i]);
        }

  }
}

return mixedTop;
}

function isTooWeakImageFeed(source) {

  const strongImages = source.filter(img => {

    const likes = img.likes || 0;
    const views = img.views || 0;
    const downloads = img.downloads || 0;

    return (
      likes >= 20 ||
      views >= 5000 ||
      downloads >= 1000
    );
  });

  // 🔥 If NO strong images exist
  if (strongImages.length === 0) {

    return source
      .filter(img => !isAnimalImage(img)).sort((a, b) => (b.likes || 0) - (a.likes || 0))
      .slice(0, 9);
  }

  return null;
}

function normalizeWord(word = "") {
  word = word.toLowerCase().trim();

  if (!word) return "";

  // couples -> couple
  if (word.endsWith("ies") && word.length > 4) {
    return word.slice(0, -3) + "y";
  }

  // cars -> car
  // dogs -> dog
  // couples -> couple
  if (word.endsWith("s") && !word.endsWith("ss")) {
    return word.slice(0, -1);
  }

  return word;
}

function isAnimalQuery(query) {
  const normalizedQuery = normalizeText(query);

  return animalKeyword.some(keyword => {
    const normalizedKeyword = normalizeText(keyword);

    return normalizedQuery
      .split(" ")
      .includes(normalizedKeyword);
  });
}

// const maxImages = 6
const maxImages = 9
export function pickStrongTopImages(images, query, count = 6, selectPexels = false) {
  let source = Array.isArray(images) ? images : [];
 
console.log("getting image on picktopimage", source,)
  if (source.length === 0) return [];

        // 🔥 CHECK WEAK FEED
  // const weakFeed = isTooWeakImageFeed(source);

  // if (weakFeed) {
  //   console.log("Weak feed detected");
  //   return weakFeed;
  // }

  // ------------------------
  // 🔥 STEP 1: BASE RANKING (your system)
  // ------------------------
 

  const ranked = source
    .map(img => {
      // const strength = computeStrengthScore(img);
      // const relevance = topicRelevanceScore(img, query);
      // const aspect = aspectBonus(img);

      const strength = computeStrengthScore(img);

const lexical = exactRelevanceScore(img, query);

const aspect = aspectBonus(img);

      // return {
      //   ...img,
      //   _baseRank:
      //     strength +
      //     relevance * 12 +
      //     aspect +
      //     ((img.id % 10) / 10) * 3 +
      //     ((img.likes || 0) > 50 ? 20 : 0)
      // };
      return {
  ...img,

  _lexicalScore: lexical,

  _baseRank:
    strength +
    lexical * 1.2 +
    aspect +
    ((img.id % 10) / 10) * 3 +
    ((img.likes || 0) > 50 ? 20 : 0)
};
    })
    .sort((a, b) => b._baseRank - a._baseRank);

  // ------------------------
  // 🔥 STEP 2: FIRST SCREEN BOOST
  // ------------------------

  const boosted = ranked.map(img => {
    const visual = visualImpactScore(img);
    const subject = subjectBoost(img);

    return {
      ...img,
      _finalRank: img._baseRank + visual + subject
    };
  }).sort((a, b) => b._finalRank - a._finalRank);

  // ------------------------
  // 🔥 STEP 3: FIRST SCREEN OVERRIDE
  // ------------------------

  // const firstScreenCount = 12;
  const firstScreenCount = Math.min(count, 12);

  // const firstScreen = boosted.slice(0, firstScreenCount);
  const animalQuery = isAnimalQuery(query);

  // const filteredBoosted = boosted.filter(img => !isAnimalImage(img) );
  const filteredBoosted = animalQuery ? boosted : boosted.filter(img => !isAnimalImage(img));

// const firstScreen = filteredBoosted.length >= firstScreenCount ? filteredBoosted.slice(0, firstScreenCount) : boosted.slice(0, firstScreenCount); 

const firstScreen = filteredBoosted.slice(0, firstScreenCount);

  // ------------------------
  // 🔥 STEP 4: REST OF FEED (original logic)
  // ------------------------

  const usedIds = new Set(firstScreen.map(img => img.id));


  if(!selectPexels){

let nextImageLength = 9 - firstScreen.length;
  //  const  rest = ranked.filter(img => img?._source !== "pexels" && !usedIds.has(img.id) && !isAnimalImage(img)).slice(0, nextImageLength);  
   fillRemaingImage(firstScreen, ranked, query, count)

    // return [ ...firstScreen, ...rest ];

//        console.table("we found",
//   firstScreen.map((img, index) => ({
//     position: index + 1,
//     id: img.id,
//     tags: img.tags,
//     likes: img.likes,
//     downloads: img.downloads,
//     views: img.views,
//     source: img._source,
//     finalScore: img._finalScore,
//     relevance: exactRelevanceScore(img, query),
//     visual: visualImpactScore(img),
//     subject: subjectBoost(img),
//     aspect: aspectBonus(img),
//     query
//   }))
// );
    return [ ...firstScreen];
    
  }else{
//       let nextImageLength = firstScreen.length === 4 ? 3 : 3
//   const rest = ranked.filter(img => img?._source === "pexels" && !usedIds.has(img.id)  && !isAnimalImage(img)).slice(0, nextImageLength);

//   let mixImages = orderPixlesAndPixbay(firstScreen, rest)
// return [...mixImages];

return filterPexelsImage(
  source,
  query
)

  }



  // ------------------------
  // 🔥 FINAL COMBINE
  // ------------------------

  // return [ ...firstScreen, ...rest ];
  // return [...mixImages];
  
  // return [...firstScreen];
}


function filterPexelsImage(
  source,
  query
){

  // 🔥 PIXABAY ONLY
// const pixabayImages = source.filter( img => img?._source !== "pexels" && !isAnimalImage(img));
const animalQuery = isAnimalQuery(query);

const pixabayImages = source.filter( img => img?._source !== "pexels" && (animalQuery || !isAnimalImage(img) && !shouldExcludeFromLongRanking(img, query))
  );

  // 🔥 PEXELS ONLY
  const pexelsImages =
    source.filter(
      img =>
        img?._source === "pexels"  && !shouldExcludeFromLongRanking(img, query)
    );

  // 🔥 RANK ONLY PIXABAY
  const rankedPixabay =  pixabayImages.map(img => {

        const strength =
          computeStrengthScore(img);

        const relevance =
          topicRelevanceScore(
            img,
            query
          );

        const aspect =
          aspectBonus(img);

        return {
          ...img,
          _score:
            strength +
            relevance * 12 +
            aspect +
            ((img.id % 10) / 10) * 3 +
            ((img.likes || 0) > 50 ? 20 : 0)
        };

      })
      .sort(
        (a, b) =>
          b._score - a._score
      );

  // 🔥 EXACTLY 6 PIXABAY
  // console.log("strong filter images", rankedPixabay)
  const topPixabay =  rankedPixabay.slice(0, maxImages);
   fillRemaingImage(rankedPixabay, topPixabay, query, maxImages)
  // 🔥 EXACTLY 3 PEXELS
  const topPexels =  pexelsImages.slice(0, 3);
  console.log("image starting point 8", topPixabay, topPexels)

  

  // 🔥 FIXED STRUCTURE
  return [

    topPexels[0],

    topPixabay[0],
    topPixabay[1],
    topPixabay[2],


//     topPexels[0],
// topPexels[1],
//     topPexels[2],

    topPexels[1],

    topPixabay[3],
    topPixabay[4],

    
    topPixabay[5],
  

// topPexels[0],
// topPexels[1],
    topPexels[2],

    topPixabay[6],
    topPixabay[7],
    topPixabay[8],
    
  

     


  ].filter(Boolean);

}



// For the long section ----------------------------------------------------

function hasPerson(img) {
  const tags = (img.tags || "").toLowerCase();

  return (
    tags.includes("person") ||
    tags.includes("people") ||
    tags.includes("portrait") ||
    tags.includes("woman") ||
    tags.includes("man") ||
    tags.includes("girl") ||
    tags.includes("boy") ||
    tags.includes("child") ||
    tags.includes("children") ||
    tags.includes("family") ||
    tags.includes("lady") ||
    tags.includes("male") ||
    tags.includes("female")
  );
}

function shouldExcludeFromLongRanking(img, query) {
  const normalizedQuery = normalizeText(query);

  // Bedroom query → don't show person-focused images
  if (
    normalizedQuery.includes("bedroom") &&
    hasPerson(img)
  ) {
    return true;
  }

  return false;
}

export function rankLongExploreNextImages(images, query) {
  if (!Array.isArray(images) || images.length === 0) {
    return [];
  }

  const animalQuery = isAnimalQuery(query);

  const ranked = images
    .filter(img => {
      // If query is animal-related, allow animal images.
      // Otherwise remove them.
      // return animalQuery || !isAnimalImage(img);
      
 if (!animalQuery && isAnimalImage(img)) {
      return false;
    }

    if (shouldExcludeFromLongRanking(img, query)) {
      return false;
    }
    return true;

    })
    .map(img => {

      const strength = computeStrengthScore(img);

      const lexical = exactRelevanceScore(
        img,
        query
      );

      const visual = visualImpactScore(img);

      const subject = subjectBoost(img);

      const aspect = aspectBonus(img);

      const boring = boringPenalty(img);

      return {
        ...img,

        _longLexicalScore: lexical,
        _longStrengthScore: strength,
        _longVisualScore: visual,

        _longRank:
          strength +
          lexical * 1.5 +
          visual +
          subject +
          aspect +
          boring
      };
    })
    .sort(
      (a, b) =>
        b._longRank - a._longRank
    );

  return ranked;
}

export function rankImages(images, query) {

  const source = Array.isArray(images) ? images : [];

  if (source.length === 0) {
    return [];
  }

  const animalQuery = isAnimalQuery(query);

  const filteredSource = animalQuery
    ? source
    : source.filter(img => !isAnimalImage(img));

  const ranked = filteredSource
    .map(img => {

      const strength = computeStrengthScore(img);
      const lexical = exactRelevanceScore(img, query);
      const visual = visualImpactScore(img);
      const subject = subjectBoost(img);
      const aspect = aspectBonus(img);
      const boring = boringPenalty(img);

      return {
        ...img,

        _lexicalScore: lexical,
        _strengthScore: strength,
        _visualScore: visual,

        _finalRank:
          strength +
          lexical * 1.2 +
          visual +
          subject +
          aspect +
          boring
      };
    })
    .sort((a, b) => b._finalRank - a._finalRank);

  return ranked;
}


export function actionPotentialScore(img, query) {
  let score = 0;

  // 1. Query relevance
  const relevance = exactRelevanceScore(img, query);
  score += relevance * 2;

  // 2. Visual impact
  const visual = visualImpactScore(img);
  score += visual;

  // 3. Strong subject
  const subject = subjectBoost(img);
  score += subject;

  // 4. Technical usability
  const width = img.imageWidth || 0;
  const height = img.imageHeight || 0;

  if (width >= 1200 && height >= 800) {
    score += 8;
  } else if (width >= 800 && height >= 600) {
    score += 4;
  }

  return score;
}

function isClickedImage(img, clickedImage) {
  if (!img || !clickedImage) return false;

  // Same object
  if (img === clickedImage) return true;
  

  // Same provider + image ID
  if (
    img.id != null &&
    clickedImage.id != null &&
    String(img.id) === String(clickedImage.id) &&
    (
      !img._source ||
      !clickedImage._source ||
      img._source === clickedImage._source
    )
  ) {
    return true;
  }

  // Compare all available image URLs
  const getUrls = (image) => [
    image.pageURL,
    image.webformatURL,
    image.largeImageURL,
    image.previewURL
  ]
    .filter(Boolean)
    .map(url => {
      try {
        const parsed = new URL(url);
        return `${parsed.hostname}${parsed.pathname}`.toLowerCase();
      } catch {
        return String(url).split("?")[0].toLowerCase();
      }
    });

  const clickedUrls = new Set(getUrls(clickedImage));

  return getUrls(img).some(url => clickedUrls.has(url));
}

// Build dynamic subject profile from clicked image metadata
const getSubjectProfile = (img) => {
  const nameTokens = tokenizeText(img?.name || "");
  const headingTokens = tokenizeText(img?.heading || "");
  const descriptionTokens = tokenizeText(img?.description || "");

  const tagGroups = String(img?.tags || "")
    .split(",")
    .map(tag => tokenizeText(tag))
    .filter(tokens => tokens.length > 0);

  return {
    nameTokens: [...new Set(nameTokens)],
    headingTokens: [...new Set(headingTokens)],
    descriptionTokens: [...new Set(descriptionTokens)],
    primaryTagTokens: [
      ...new Set(tagGroups.slice(0, 5).flat())
    ],
    allTagTokens: [
      ...new Set(tagGroups.flat())
    ]
  };
};

function isLikelySamePhoto(img, clickedImage) {
  if (!img || !clickedImage) return false;

  const getTokens = (image) => new Set(
    tokenizeText([
      image.name,
      image.heading,
      image.description
    ].filter(Boolean).join(" "))
  );

  const a = getTokens(img);
  const b = getTokens(clickedImage);

  if (!a.size || !b.size) return false;

  const commonTokens = [...a].filter(token => b.has(token));

  // Compare shared metadata against the smaller token set.
  const similarity =
    commonTokens.length / Math.min(a.size, b.size);

  return similarity >= 0.80;
}
const getWeightedSubjectTokens = (profile) => {
  const weights = new Map();

  const addTokens = (tokens, weight) => {
    tokens.forEach(token => {
      weights.set(
        token,
        (weights.get(token) || 0) + weight
      );
    });
  };

  // Strongest metadata signals
  addTokens(profile.nameTokens, 5);
  addTokens(profile.headingTokens, 3);

  // Supporting metadata signals
  addTokens(profile.descriptionTokens, 2);
  addTokens(profile.primaryTagTokens, 2);
  addTokens(profile.allTagTokens, 1);

  return weights;
};


export function rankRightRelatedImages(
  images,
  clickedImage,
  query,
  count = 4
) {
  if (
    !Array.isArray(images) ||
    images.length === 0 ||
    !clickedImage
  ) {
    return [];
  }

  const safeCount = Math.max(
    0,
    Math.floor(Number(count) || 0)
  );

  if (safeCount === 0) return [];

  // ----------------------------------------
  // STEP 1: Build clicked image subject profile
  // ----------------------------------------

  const clickedSubjectProfile = getSubjectProfile(clickedImage);

  const clickedSubjectWeights = getWeightedSubjectTokens(
    clickedSubjectProfile
  );

  const animalQuery = isAnimalQuery(query);

  // ----------------------------------------
  // STEP 2: Prepare candidate images
  // ----------------------------------------

  const source = images.filter(img => {
    if (!img) return false;

    // NEVER include the clicked image
    if (isClickedImage(img, clickedImage) ||
  isLikelySamePhoto(img, clickedImage)) {
      return false;
    }

    if (!animalQuery && isAnimalImage(img)) {
      return false;
    }

    return true;
  });

  if (source.length === 0) return [];

  // ----------------------------------------
  // STEP 3: Prepare candidate profiles
  // ----------------------------------------

  const candidateSubjectProfiles = source.map(img =>
    getSubjectProfile(img)
  );

  const candidateSubjectWeights = candidateSubjectProfiles.map(
    profile => getWeightedSubjectTokens(profile)
  );

  const clickedTokens = new Set(
    getImageTagTokens(clickedImage)
  );

  const candidateTokenSets = source.map(
    img => new Set(getImageTagTokens(img))
  );

  // ----------------------------------------
  // STEP 4: Calculate tag rarity (IDF)
  // ----------------------------------------

  const documentFrequency = new Map();

  candidateTokenSets.forEach(tokens => {
    tokens.forEach(token => {
      documentFrequency.set(
        token,
        (documentFrequency.get(token) || 0) + 1
      );
    });
  });

  const totalDocuments = source.length;

  const tagWeights = new Map();

  for (const [token, frequency] of documentFrequency) {
    tagWeights.set(
      token,
      Math.log(
        (totalDocuments + 1) / (frequency + 1)
      ) + 1
    );
  }

  const getTagWeight = token =>
    tagWeights.get(token) || 1;

  const clickedTagWeight = [...clickedTokens].reduce(
    (total, token) => total + getTagWeight(token),
    0
  );

  // ----------------------------------------
  // STEP 5: Calculate clicked subject weight
  // ----------------------------------------

  const clickedSubjectTotal = [...clickedSubjectWeights.values()]
    .reduce((total, weight) => total + weight, 0);

  // ----------------------------------------
  // STEP 6: Rank candidates
  // ----------------------------------------

  const ranked = source.map((img, index) => {
    const candidateTokens = candidateTokenSets[index];

    const candidateWeights = candidateSubjectWeights[index];

    // ----------------------------------------
    // A. Weighted subject similarity
    // ----------------------------------------

    const candidateSubjectTotal = [
      ...candidateWeights.values()
    ].reduce((total, weight) => total + weight, 0);

    let matchedSubjectWeight = 0;

    const matchedSubjectTokens = [];

    clickedSubjectWeights.forEach((clickedWeight, token) => {
      const candidateWeight = candidateWeights.get(token);

      if (candidateWeight !== undefined) {
        matchedSubjectWeight += Math.min(
          clickedWeight,
          candidateWeight
        );

        matchedSubjectTokens.push(token);
      }
    });

    const subjectCoverage = clickedSubjectTotal
      ? matchedSubjectWeight / clickedSubjectTotal
      : 0;

    const subjectPrecision = candidateSubjectTotal
      ? matchedSubjectWeight / candidateSubjectTotal
      : 0;

    const subjectSimilarity =
      subjectCoverage + subjectPrecision > 0
        ? (
            (2 * subjectCoverage * subjectPrecision) /
            (subjectCoverage + subjectPrecision)
          ) * 100
        : 0;

    // ----------------------------------------
    // B. Existing tag similarity
    // ----------------------------------------

    const matchedTokens = [...clickedTokens].filter(
      token => candidateTokens.has(token)
    );

    const candidateTagWeight = [...candidateTokens].reduce(
      (total, token) => total + getTagWeight(token),
      0
    );

    const matchedTagWeight = matchedTokens.reduce(
      (total, token) => total + getTagWeight(token),
      0
    );

    const coverage = clickedTagWeight
      ? matchedTagWeight / clickedTagWeight
      : 0;

    const precision = candidateTagWeight
      ? matchedTagWeight / candidateTagWeight
      : 0;

    const baseSimilarity =
      coverage + precision > 0
        ? (
            (2 * coverage * precision) /
            (coverage + precision)
          ) * 100
        : 0;

    const distinctiveMatches = matchedTokens.filter(
      token => getTagWeight(token) >= 1.5
    );

    const multipleMatchBonus =
      Math.min(distinctiveMatches.length, 3) * 4;

    const similarityScore = Math.min(
      100,
      baseSimilarity + multipleMatchBonus
    );

    // ----------------------------------------
    // C. Existing ranking signals
    // ----------------------------------------

    const lexical = exactRelevanceScore(img, query);
    const strength = computeStrengthScore(img);
    const visual = visualImpactScore(img);
    const aspect = aspectBonus(img);
    const boring = boringPenalty(img);

    // ----------------------------------------
    // D. Combined ranking score
    // ----------------------------------------

    const rightRelatedRank =
      subjectSimilarity * 1.5 +
      similarityScore * 1.0 +
      lexical * 0.35 +
      visual +
      Math.log1p(strength) * 2 +
      aspect +
      boring;

    return {
      ...img,

      _lexicalScore: lexical,

      _clickedSubjectSimilarity: subjectSimilarity,
      _clickedSubjectCoverage: subjectCoverage,
      _clickedSubjectPrecision: subjectPrecision,
      _clickedSubjectMatchedTokens: matchedSubjectTokens,

      _clickedImageSimilarity: similarityScore,
      _clickedImageCoverage: coverage,
      _clickedImagePrecision: precision,
      _clickedImageMatchedTags: matchedTokens,
      _clickedImageDistinctiveMatches: distinctiveMatches,

      _rightRelatedRank: rightRelatedRank,

      _matchType: "strong"
    };
  });

  // ----------------------------------------
  // STEP 7: Sort candidates
  // ----------------------------------------

  ranked.sort(
    (a, b) => b._rightRelatedRank - a._rightRelatedRank
  );

  // ----------------------------------------
  // STEP 8: Select genuinely related images
  // ----------------------------------------

  const stronglyRelated = ranked.filter(img => {
    const hasDistinctiveMatch =
      img._clickedImageDistinctiveMatches.length >= 1;

    const hasStrongSubjectMatch =
      img._clickedSubjectSimilarity >= 30;

    return (
      hasStrongSubjectMatch ||
      (
        img._clickedImageSimilarity >= 25 &&
        hasDistinctiveMatch
      )
    );
  });

  const result = stronglyRelated.slice(0, safeCount);

  // ----------------------------------------
  // STEP 9: Shared duplicate tracking
  // ----------------------------------------

  const getImageKey = img =>
    `${img._source || ""}-${
      img.id ??
      img.pageURL ??
      img.webformatURL ??
      ""
    }`;

  const usedIds = new Set(
    result.map(getImageKey)
  );

  // ----------------------------------------
  // STEP 10: First fallback - topic relevance
  // ----------------------------------------

  if (result.length < safeCount) {
    const topicFallback = ranked.filter(
      img => img._lexicalScore > 0
    );

    for (const img of topicFallback) {
      if (result.length >= safeCount) break;

      const key = getImageKey(img);

      if (usedIds.has(key)) continue;

      result.push({
        ...img,
        _rightRelatedFallback: true,
        _matchType: "topic-fallback"
      });

      usedIds.add(key);
    }
  }

  // ----------------------------------------
  // STEP 11: Final fallback - general ranking
  // ----------------------------------------

  if (result.length < safeCount) {
    const generalFallback = pickStrongTopImages(
      source,
      query,
      safeCount,
      false
    );

    for (const img of generalFallback) {
      if (result.length >= safeCount) break;

      const key = getImageKey(img);

      if (usedIds.has(key)) continue;

      result.push({
        ...img,
        _rightRelatedFallback: true,
        _matchType: "general-fallback"
      });

      usedIds.add(key);
    }
  }

  // ----------------------------------------
  // STEP 12: Debug results
  // ----------------------------------------

  /*
  if (process.env.NODE_ENV === "development") {
    console.table(
      result.map(img => ({
        id: img.id,
        tags: img.tags,

        subjectSimilarity:
          img._clickedSubjectSimilarity,

        subjectCoverage:
          img._clickedSubjectCoverage,

        subjectPrecision:
          img._clickedSubjectPrecision,

        matchedSubjectTokens:
          img._clickedSubjectMatchedTokens?.join(", "),

        tagSimilarity:
          img._clickedImageSimilarity,

        matchedTags:
          img._clickedImageMatchedTags?.join(", "),

        lexical: img._lexicalScore,
        matchType: img._matchType,
        rank: img._rightRelatedRank
      }))
    );
  }
  */

  // ----------------------------------------
  // STEP 13: Final safety
  // ----------------------------------------

  const finalResult = result.filter(
    img => !isClickedImage(img, clickedImage)
  );

//   console.table("CLICKED IMAGE: filtering data ", 
//   finalResult.map((img, index) => ({
//     position: index + 1,
//     id: img.id,
//     source: img._source,
//     name: img.name,
//     heading: img.heading,
//     tags: img.tags,
//     url: img.webformatURL,
//     subjectSimilarity: img._clickedSubjectSimilarity,
//     matchedSubjects: img._clickedSubjectMatchedTokens?.join(", "),
//     matchType: img._matchType
//   }))
// );
// console.log("CLICKED IMAGE:", {
//   id: clickedImage.id,
//   source: clickedImage._source,
//   name: clickedImage.name,
//   url: clickedImage.webformatURL
// });
  return finalResult.slice(0, safeCount);
}



////////------------------------------- Below function we were using --------------------------
// export function rankRightRelatedImages(
//   images,
//   clickedImage,
//   query,
//   count = 4
// ) {
//   if (
//     !Array.isArray(images) ||
//     images.length === 0 ||
//     !clickedImage
//   ) {
//     return [];
//   }

//   const animalQuery = isAnimalQuery(query);

//   // ----------------------------------------
//   // STEP 1: Prepare candidate images
//   // ----------------------------------------
  

//  const source = images.filter(img => {
//   if (!img) return false;

//   // NEVER include the clicked image
//   if (isClickedImage(img, clickedImage)) {
//     return false;
//   }

//   if (!animalQuery && isAnimalImage(img)) {
//     return false;
//   }

//   return true;
// });

//   if (source.length === 0) return [];

//   const safeCount = Math.max(0, Math.floor(Number(count) || 0));

//   if (safeCount === 0) return [];

//   const clickedTokens = new Set(
//     getImageTagTokens(clickedImage)
//   );

//   if (clickedTokens.size === 0) {
//     return pickStrongTopImages(
//       source,
//       query,
//       safeCount,
//       false
//     );
//   }

//   // ----------------------------------------
//   // STEP 2: Prepare candidate tag sets
//   // ----------------------------------------

//   const candidateTokenSets = source.map(
//     (img) => new Set(getImageTagTokens(img))
//   );

//   // ----------------------------------------
//   // STEP 3: Calculate tag rarity (IDF)
//   // ----------------------------------------

//   const documentFrequency = new Map();

//   candidateTokenSets.forEach((tokens) => {
//     tokens.forEach((token) => {
//       documentFrequency.set(
//         token,
//         (documentFrequency.get(token) || 0) + 1
//       );
//     });
//   });

//   const totalDocuments = source.length;

//   // Calculate each token's weight only once.
//   const tagWeights = new Map();

//   for (const [token, frequency] of documentFrequency) {
//     tagWeights.set(
//       token,
//       Math.log(
//         (totalDocuments + 1) / (frequency + 1)
//       ) + 1
//     );
//   }

//   const getTagWeight = (token) =>
//     tagWeights.get(token) || 1;

//   // Calculate clicked image weight only once.
//   const clickedWeight = [...clickedTokens].reduce(
//     (total, token) => total + getTagWeight(token),
//     0
//   );

//   // ----------------------------------------
//   // STEP 4: Rank by clicked-image similarity
//   // ----------------------------------------

//   const ranked = source.map((img, index) => {
//     const candidateTokens = candidateTokenSets[index];

//     const matchedTokens = [...clickedTokens].filter(
//       (token) => candidateTokens.has(token)
//     );

//     // Total information weight of candidate tags.
//     const candidateWeight = [...candidateTokens].reduce(
//       (total, token) => total + getTagWeight(token),
//       0
//     );

//     // Weight of shared tags.
//     const matchedWeight = matchedTokens.reduce(
//       (total, token) => total + getTagWeight(token),
//       0
//     );

//     const coverage = clickedWeight
//       ? matchedWeight / clickedWeight
//       : 0;

//     const precision = candidateWeight
//       ? matchedWeight / candidateWeight
//       : 0;

//     // ----------------------------------------
//     // STEP 5: Weighted F1 similarity
//     // ----------------------------------------

//     const baseSimilarity =
//       coverage + precision > 0
//         ? (
//             (2 * coverage * precision) /
//             (coverage + precision)
//           ) * 100
//         : 0;

//     // ----------------------------------------
//     // STEP 6: Distinctive tag bonus
//     // ----------------------------------------

//     const distinctiveMatches = matchedTokens.filter(
//       (token) => getTagWeight(token) >= 1.5
//     );

//     const multipleMatchBonus =
//       Math.min(distinctiveMatches.length, 3) * 4;

//     const similarityScore = Math.min(
//       100,
//       baseSimilarity + multipleMatchBonus
//     );

//     // ----------------------------------------
//     // STEP 7: Preserve existing ranking signals
//     // ----------------------------------------

//     const lexical = exactRelevanceScore(img, query);
//     const strength = computeStrengthScore(img);
//     const visual = visualImpactScore(img);
//     const aspect = aspectBonus(img);
//     const boring = boringPenalty(img);

//     return {
//       ...img,

//       _lexicalScore: lexical,

//       _clickedImageSimilarity: similarityScore,
//       _clickedImageCoverage: coverage,
//       _clickedImagePrecision: precision,

//       _clickedImageMatchedTags: matchedTokens,
//       _clickedImageDistinctiveMatches: distinctiveMatches,

//       _rightRelatedRank:
//         similarityScore * 1.5 +
//         lexical * 0.35 +
//         visual +
//         Math.log1p(strength) * 2 +
//         aspect +
//         boring,

//       _matchType: "strong"
//     };
//   });

//   // ----------------------------------------
//   // STEP 8: Sort candidates
//   // ----------------------------------------

//   ranked.sort(
//     (a, b) => b._rightRelatedRank - a._rightRelatedRank
//   );

//   // ----------------------------------------
//   // STEP 9: Select genuinely strong matches
//   // ----------------------------------------

//   const stronglyRelated = ranked.filter((img) => {
//     const hasDistinctiveMatch =
//       img._clickedImageDistinctiveMatches.length >= 1;

//     return (
//       img._clickedImageSimilarity >= 25 &&
//       hasDistinctiveMatch
//     );
//   });

//   const result = stronglyRelated.slice(0, safeCount);

//   // ----------------------------------------
//   // STEP 10: Shared duplicate tracking
//   // ----------------------------------------

//   const getImageKey = (img) =>
//     `${img._source || ""}-${
//       img.id ??
//       img.pageURL ??
//       img.webformatURL ??
//       ""
//     }`;

//   const usedIds = new Set(
//     result.map(getImageKey)
//   );

//   // ----------------------------------------
//   // STEP 11: First fallback - topic relevance
//   // ----------------------------------------

//   if (result.length < safeCount) {
//     const topicFallback = ranked.filter(
//       (img) => img._lexicalScore > 0
//     );

//     for (const img of topicFallback) {
//       if (result.length >= safeCount) break;

//       const key = getImageKey(img);

//       if (usedIds.has(key)) continue;

//       result.push({
//         ...img,
//         _rightRelatedFallback: true,
//         _matchType: "topic-fallback"
//       });

//       usedIds.add(key);
//     }
//   }

//   // ----------------------------------------
//   // STEP 12: Final fallback - general ranking
//   // ----------------------------------------

//   if (result.length < safeCount) {
//     const generalFallback = pickStrongTopImages(
//       source,
//       query,
//       safeCount,
//       false
//     );

//     for (const img of generalFallback) {
//       if (result.length >= safeCount) break;

//       const key = getImageKey(img);

//       if (usedIds.has(key)) continue;

//       result.push({
//         ...img,
//         _rightRelatedFallback: true,
//         _matchType: "general-fallback"
//       });

//       usedIds.add(key);
//     }
//   }

//   // ----------------------------------------
//   // STEP 13: Debug results (development only)
//   // ----------------------------------------

//   /*
//   if (process.env.NODE_ENV === "development") {
//     console.table(
//       result.map((img) => ({
//         id: img.id,
//         tags: img.tags,
//         similarity: img._clickedImageSimilarity,
//         coverage: img._clickedImageCoverage,
//         precision: img._clickedImagePrecision,
//         matchedTags: img._clickedImageMatchedTags?.join(", "),
//         distinctiveTags:
//           img._clickedImageDistinctiveMatches?.join(", "),
//         lexical: img._lexicalScore,
//         matchType: img._matchType,
//         rank: img._rightRelatedRank
//       }))
//     );
//   }
//   */

//   // return result.slice(0, safeCount);
  
//   // FINAL SAFETY: Never return the clicked image
// const finalResult = result.filter(
//   img => !isClickedImage(img, clickedImage)
// );

// return finalResult.slice(0, safeCount);
// }